"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDetail = void 0;
const Yup = __importStar(require("yup"));
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const uuid_1 = require("uuid");
const export_dialog_1 = require("../../modules/export/components/dialog/export-dialog/export-dialog");
const evidence_defaults_context_1 = require("../evidence-defaults/evidence-defaults-context");
const evidence_context_1 = require("../evidence/evidence-context");
const navigation_context_1 = require("../navigation/navigation-context");
const snackbar_context_1 = require("../snackbar/snackbar-context");
const snackbar_types_1 = require("../snackbar/snackbar-types");
const empty_component_1 = require("../../utils/empty-component");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const detail_container_1 = require("./detail-container");
const detail_toolbar_2_1 = require("./detail-toolbar-2");
const detail_types_1 = require("./detail-types");
const detail_update_hook_1 = require("./detail-update-hook");
const empty_detail_container_1 = require("./empty-detail-container");
const entity_locking_hook_1 = require("./entity-locking-hook");
const detail_export_hook_1 = require("./hooks/detail-export-hook");
function useDetail(options, ref) {
    var _a;
    const formRef = (0, react_1.useRef)(null);
    const detailContainerRef = (0, react_1.useRef)(null);
    const defaults = (0, react_1.useContext)(evidence_defaults_context_1.EvidenceDefaultsContext);
    const props = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return ({
            ToolbarComponent: (_a = defaults.ToolbarComponent) !== null && _a !== void 0 ? _a : detail_toolbar_2_1.DetailToolbar,
            ContainerComponent: (_b = defaults.ContainerComponent) !== null && _b !== void 0 ? _b : detail_container_1.DetailContainer,
            EmptyContainerComponent: (_c = defaults.EmptyContainerComponent) !== null && _c !== void 0 ? _c : empty_detail_container_1.EmptyDetailContainer,
            FieldsComponent: (_d = defaults.FieldsComponent) !== null && _d !== void 0 ? _d : empty_component_1.EmptyComponent,
            GeneralFieldsComponent: (_e = defaults.GeneralFieldsComponent) !== null && _e !== void 0 ? _e : empty_component_1.EmptyComponent,
            ExportDialogComponent: export_dialog_1.ExportDialog,
            onPersisted: lodash_1.noop,
            initNewItem: defaultInitNewItem,
            showErrorPanel: false,
            resetScrollbarPosition: false,
            reloadOnUpdate: (_f = defaults.reloadDetailOnUpdate) !== null && _f !== void 0 ? _f : false,
            onUpdate: defaults.onDetailUpdate,
            validationSchema: Yup.object(),
            entityLocking: {
                enabled: (_h = (((_g = defaults.entityLocking) === null || _g === void 0 ? void 0 : _g.enabled) && !!options.entityName)) !== null && _h !== void 0 ? _h : false,
                expirationReminderTime: (_k = (_j = defaults.entityLocking) === null || _j === void 0 ? void 0 : _j.expirationReminderTime) !== null && _k !== void 0 ? _k : 300,
            },
            lock: () => false,
            reportTag: null,
            ...options,
            toolbarProps: {
                ...options.toolbarProps,
            },
        });
    }, [
        defaults.ContainerComponent,
        defaults.EmptyContainerComponent,
        defaults.FieldsComponent,
        defaults.GeneralFieldsComponent,
        defaults.ToolbarComponent,
        defaults.reloadDetailOnUpdate,
        defaults.onDetailUpdate,
        defaults.entityLocking,
        options,
    ]);
    const { exportDialogRef, openExportDialog, closeExportDialog } = (0, detail_export_hook_1.useDetailExports)();
    const intl = (0, react_intl_1.useIntl)();
    const { showSnackbar } = (0, react_1.useContext)(snackbar_context_1.SnackbarContext);
    const confirmTitle = intl.formatMessage({
        id: 'EAS_DETAIL_LEAVE_DIALOG_TITLE',
        defaultMessage: 'Zanechání změn',
    });
    const confirmText = intl.formatMessage({
        id: 'EAS_DETAIL_LEAVE_DIALOG_TEXT',
        defaultMessage: 'Skutečně chcete opustit rozpracované změny?',
    });
    const { registerPrompt, unregisterPrompt } = (0, react_1.useContext)(navigation_context_1.NavigationContext);
    const { tableRef, detailRef } = (0, react_1.useContext)(evidence_context_1.EvidenceContext);
    const prompt = (0, react_1.useMemo)(() => ({
        title: confirmTitle,
        text: confirmText,
        clearCallback: () => {
            var _a, _b;
            (_a = detailRef.current) === null || _a === void 0 ? void 0 : _a.cancelEditing();
            (_b = formRef.current) === null || _b === void 0 ? void 0 : _b.resetValidation();
        },
    }), [confirmTitle, confirmText, detailRef]);
    const [mode, setMode] = (0, react_1.useState)(detail_types_1.DetailMode.NONE);
    const refreshListeners = (0, react_1.useRef)([]);
    (0, detail_update_hook_1.useDetailUpdate)({
        enabled: props.reloadOnUpdate || !!props.onUpdate,
        source: props.source,
        mode,
        onUpdate: props.onUpdate,
    });
    const { acquireLock: lockEntity, releaseLock: unlockEntity, expiration: lockExpiration, lockedByUser, keepLockAlive, remindExpiration: remindLockExpiration, forceReleaseLock: forceUnlockEntity, } = (0, entity_locking_hook_1.useEntityLocking)({
        enabled: !!props.entityLocking.enabled,
        source: props.source,
        entityName: props.entityName,
        mode,
        setMode,
        forceReleasePermission: (_a = defaults.entityLocking) === null || _a === void 0 ? void 0 : _a.forceReleasePermission,
    });
    const isLocked = (0, react_1.useMemo)(() => props.lock(options.source.data), [options.source.data, props]);
    const setActive = (0, event_callback_hook_1.useEventCallback)(async (id) => {
        var _a;
        if (id !== null) {
            if (id !== ((_a = options.source.data) === null || _a === void 0 ? void 0 : _a.id)) {
                const data = await options.source.get(id);
                if (data !== undefined) {
                    setMode(detail_types_1.DetailMode.VIEW);
                }
            }
        }
        else {
            options.source.reset();
            setMode(detail_types_1.DetailMode.NONE);
        }
    });
    const callRefreshListeners = (0, event_callback_hook_1.useEventCallback)(() => {
        refreshListeners.current.forEach((l) => l());
    });
    const refresh = (0, event_callback_hook_1.useEventCallback)(() => {
        var _a;
        options.source.refresh();
        callRefreshListeners();
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.resetValidation();
    });
    const refreshAll = (0, event_callback_hook_1.useEventCallback)(() => {
        var _a, _b, _c;
        if (mode === detail_types_1.DetailMode.VIEW) {
            options.source.refresh();
            callRefreshListeners();
            (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.resetValidation();
            props.onPersisted((_c = (_b = options.source.data) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null);
        }
    });
    const startNew = (0, event_callback_hook_1.useEventCallback)((data) => {
        var _a;
        options.source.reset({ ...props.initNewItem(), ...data });
        setMode(detail_types_1.DetailMode.NEW);
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.resetValidation();
        registerPrompt(prompt);
    });
    const startEditing = (0, event_callback_hook_1.useEventCallback)(async () => {
        lockEntity();
        if (options.source.data !== null) {
            setMode(detail_types_1.DetailMode.EDIT);
            registerPrompt(prompt);
        }
    });
    const cancelEditing = (0, event_callback_hook_1.useEventCallback)(() => {
        var _a, _b, _c, _d, _e;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.resetValidation();
        if (mode === detail_types_1.DetailMode.NEW) {
            const id = (_b = tableRef.current) === null || _b === void 0 ? void 0 : _b.activeRow;
            if (id) {
                setMode(detail_types_1.DetailMode.VIEW);
                (_c = detailRef.current) === null || _c === void 0 ? void 0 : _c.setActive(id);
            }
            else {
                setMode(detail_types_1.DetailMode.NONE);
                options.source.reset();
                (_d = formRef.current) === null || _d === void 0 ? void 0 : _d.clearForm();
            }
            unregisterPrompt(prompt);
        }
        else if (mode === detail_types_1.DetailMode.EDIT) {
            setMode(detail_types_1.DetailMode.VIEW);
            unregisterPrompt(prompt);
            (_e = formRef.current) === null || _e === void 0 ? void 0 : _e.setFieldValues(options.source.data);
        }
        unlockEntity();
    });
    const save = (0, event_callback_hook_1.useEventCallback)(async () => {
        if (formRef.current != null) {
            const errors = await validate(true);
            if (errors.length > 0) {
                return;
            }
            if (mode === detail_types_1.DetailMode.NEW) {
                const values = formRef.current.getFieldValues();
                const data = await options.source.create(values);
                unregisterPrompt(prompt);
                if (data !== undefined) {
                    (0, react_dom_1.unstable_batchedUpdates)(() => {
                        setActive(data.id);
                        setMode(detail_types_1.DetailMode.VIEW);
                        props.onPersisted(data.id);
                        callRefreshListeners();
                    });
                }
            }
            else if (mode === detail_types_1.DetailMode.EDIT) {
                const values = formRef.current.getFieldValues();
                const data = await options.source.update(values, options.source.data);
                unregisterPrompt(prompt);
                if (data !== undefined) {
                    setMode(detail_types_1.DetailMode.VIEW);
                    props.onPersisted(data.id);
                    callRefreshListeners();
                }
            }
            unlockEntity();
        }
    });
    const del = (0, event_callback_hook_1.useEventCallback)(async () => {
        var _a, _b;
        if (mode === detail_types_1.DetailMode.VIEW && options.source.data !== null) {
            await options.source.del(options.source.data.id);
            options.source.reset();
            (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.resetValidation();
            (_b = tableRef.current) === null || _b === void 0 ? void 0 : _b.resetSelection();
            setMode(detail_types_1.DetailMode.NONE);
            props.onPersisted(null);
        }
    });
    const validate = (0, event_callback_hook_1.useEventCallback)(async (hideSuccess = false, customSchema) => {
        if (formRef.current != null) {
            const errors = await formRef.current.validateForm(customSchema);
            const isValid = errors.length === 0;
            if (isValid) {
                if (!hideSuccess) {
                    const message = intl.formatMessage({
                        id: 'EAS_DETAIL_VALIDATION_MSG_SUCCESS',
                        defaultMessage: 'Formulář je v pořádku.',
                    });
                    showSnackbar(message, snackbar_types_1.SnackbarVariant.SUCCESS);
                }
            }
            else {
                const message = intl.formatMessage({
                    id: 'EAS_DETAIL_VALIDATION_MSG_ERROR',
                    defaultMessage: 'Formulář obsahuje chyby.',
                });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR, true);
            }
            return errors;
        }
        return [];
    });
    const addRefreshListener = (0, event_callback_hook_1.useEventCallback)((listener) => {
        refreshListeners.current = [...refreshListeners.current, listener];
    });
    const removeRefreshListener = (0, event_callback_hook_1.useEventCallback)((listener) => {
        refreshListeners.current = refreshListeners.current.filter((l) => l !== listener);
    });
    const context = (0, react_1.useMemo)(() => ({
        formRef: formRef.current,
        source: props.source,
        FieldsComponent: props.FieldsComponent,
        ExportDialogComponent: props.ExportDialogComponent,
        onPersisted: props.onPersisted,
        isExisting: mode === detail_types_1.DetailMode.VIEW || mode === detail_types_1.DetailMode.EDIT,
        mode,
        setMode,
        showErrorPanel: props.showErrorPanel,
        refresh,
        refreshAll,
        setActive,
        startNew,
        startEditing,
        cancelEditing,
        del,
        save,
        validate,
        addRefreshListener,
        removeRefreshListener,
        showButton: props.toolbarProps.showBtn,
        disableButton: props.toolbarProps.disableBtn,
        isLocked,
        reportTag: props.reportTag,
        openExportDialog,
        closeExportDialog,
        entityLocking: {
            ...props.entityLocking,
            lockedByUser,
            lockExpiration,
            keepLockAlive,
            remindLockExpiration,
            forceUnlockEntity,
        },
    }), [
        props.source,
        props.FieldsComponent,
        props.ExportDialogComponent,
        props.onPersisted,
        props.showErrorPanel,
        props.toolbarProps.showBtn,
        props.toolbarProps.disableBtn,
        props.reportTag,
        props.entityLocking,
        mode,
        refresh,
        refreshAll,
        setActive,
        startNew,
        startEditing,
        cancelEditing,
        del,
        save,
        validate,
        addRefreshListener,
        removeRefreshListener,
        isLocked,
        openExportDialog,
        closeExportDialog,
        lockedByUser,
        lockExpiration,
        keepLockAlive,
        remindLockExpiration,
        forceUnlockEntity,
    ]);
    /**
     * Prompt is unregistered on unmount.
     *
     * Fixing usecase when browsers back button is hit when detail.mode == 'NEW' or 'EDIT'.
     */
    (0, react_1.useEffect)(() => {
        return () => {
            unregisterPrompt(prompt);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.setFieldValues((_b = options.source.data) !== null && _b !== void 0 ? _b : {});
    }, [options.source.data]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (props.resetScrollbarPosition &&
            ((_a = detailContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTop) !== 0 &&
            options.source.loading) {
            (_b = detailContainerRef.current) === null || _b === void 0 ? void 0 : _b.scroll({ top: 0 });
        }
    }, [options.source.loading]);
    (0, react_1.useImperativeHandle)(ref, () => context, [context]);
    const editing = mode === detail_types_1.DetailMode.NEW || mode === detail_types_1.DetailMode.EDIT;
    return {
        props,
        context,
        formRef,
        detailContainerRef,
        exportDialogRef,
        editing,
    };
}
exports.useDetail = useDetail;
function defaultInitNewItem() {
    return {
        id: (0, uuid_1.v4)(),
    };
}
//# sourceMappingURL=detail-hook.js.map